import customAxios from '../../actions/customAxios';
import {store} from '../../store';
import {generateFileOptions} from '../../actions/config';

export const uploadNews = (file, title, textData, contentType, description) => {

    const {auth} = store.getState();
    
    const form = new FormData();

    form.append('file', file);
    form.append('fileType', contentType ? contentType : "image/jpg");
    form.append('title', title);
    form.append('textData', textData);
    form.append('description', description);
    form.append('active', true);

    const boundary = form._boundary;

    const fileOptions = generateFileOptions(auth, boundary);

    const url = `/vins/VInsAdmin/news/addNews`;

    return customAxios.post(url, form, fileOptions);
}

export const deleteNews = async (newsId) => {
    const url = `/vins/VInsAdmin/news/deleteNews/${newsId}`;

    return customAxios.get(url);  
  }
